import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModernSidebarComponent } from './modern-sidebar.component';
import { RouterModule } from '@angular/router';



@NgModule({
  declarations: [ModernSidebarComponent],
  imports: [
    CommonModule, RouterModule
  ],
  exports:[ModernSidebarComponent]
})
export class ModernSidebarModule { }
